module.exports = __webpack_public_path__ + "33aa906dc8cd3ebbf52c22c3cc068a43.mp3";